import { useEffect, useState } from 'react';
import { ArrowUpRight, Menu, X } from 'lucide-react';
import { navigation, siteConfig } from '../data/siteData.js';
import useBodyLock from '../hooks/useBodyLock.js';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useBodyLock(open);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenu = () => setOpen(false);

  return (
    <header className={`site-header ${scrolled ? 'site-header--scrolled' : ''}`}>
      <div className="container nav-shell">
        <a className="brand" href="#top" aria-label="Ugrás a kezdőlap tetejére" onClick={closeMenu}>
          <span className="brand-mark">{siteConfig.shortBrand}</span>
          <span className="brand-copy">
            <strong>MARTIN</strong>
            <small>COACHING</small>
          </span>
        </a>

        <nav className={`desktop-nav ${open ? 'desktop-nav--open' : ''}`} aria-label="Fő navigáció">
          {navigation.map((item) => (
            <a key={item.href} href={item.href} onClick={closeMenu}>
              {item.label}
            </a>
          ))}
          <a className="button button--small button--gold mobile-only-cta" href="#kapcsolat" onClick={closeMenu}>
            Ingyenes konzultáció
            <ArrowUpRight size={17} />
          </a>
        </nav>

        <a className="button button--small button--gold nav-cta" href="#kapcsolat">
          Konzultáció
          <ArrowUpRight size={17} />
        </a>

        <button
          className="menu-toggle"
          type="button"
          aria-label={open ? 'Menü bezárása' : 'Menü megnyitása'}
          aria-expanded={open}
          onClick={() => setOpen((current) => !current)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>
    </header>
  );
}
